import { render, staticRenderFns } from "./WarehouseApplication.vue?vue&type=template&id=8f945e38&scoped=true&"
import script from "./WarehouseApplication.vue?vue&type=script&lang=js&"
export * from "./WarehouseApplication.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseApplication.vue?vue&type=style&index=0&id=8f945e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f945e38",
  null
  
)

export default component.exports